import React, { Component } from 'react';

const Header = (props) => (
    <header>
        <h1 className="appTitle">Soundzy</h1>
    </header>
);

export default Header;